export default __webpack_public_path__ + "static/media/pics-register.88179488.jpg";